import { v4 as uuidv4 } from "uuid";

export const generateFilename = (folder) => {
  return `${folder}/${uuidv4()}`;
};
